import BrandFreeAreaService from '@/services/free-area/brand-free-area'

export default class FooterFreeAreaService extends BrandFreeAreaService {
  protected get freeAreaPaths(): string[] {
    return [
      'InsideFooterFreeArea',
    ]
  }
}
